import { useLang } from "@/contexts/LanguageContext";

/**
 * Yusi Actions — Phase 1.
 * Client-side filter tabs. Filters are evaluated against the action state
 * derived from `task.status` (see ActionStateChip.statusToActionState).
 *
 * The "Rechecked" state is intentionally not a top-level tab in Phase 1
 * (only chip-level distinction). It shows under "All".
 */

const COPY = {
  tr: {
    all: "Tümü",
    detected: "Tespit edilenler",
    applied: "Uygulananlar",
    completed: "Tamamlananlar",
  },
  en: {
    all: "All",
    detected: "Detected",
    applied: "Applied",
    completed: "Completed",
  },
};

const ORDER = ["all", "detected", "applied", "completed"];

export default function ActionsFilterTabs({ value, onChange, counts = {} }) {
  const { lang } = useLang();
  const t = COPY[lang] || COPY.tr;
  return (
    <div className="flex flex-wrap items-center gap-1.5 sm:gap-2" role="tablist" data-testid="actions-filter-tabs">
      {ORDER.map((key) => {
        const active = value === key;
        const count = counts[key];
        return (
          <button
            key={key}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(key)}
            className={[
              "rounded-full px-3.5 py-1.5 text-xs sm:text-sm transition-colors border",
              active
                ? "bg-cyan-500/15 border-cyan-500/40 text-white"
                : "bg-white/[0.02] border-white/5 text-slate-300 hover:bg-white/[0.04] hover:text-white",
            ].join(" ")}
            data-testid={`actions-filter-${key}`}
          >
            <span>{t[key]}</span>
            {typeof count === "number" && (
              <span className={`ml-1.5 text-[10px] ${active ? "text-cyan-200" : "text-slate-500"}`}>
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
